import { Box3, Vector3 } from "three";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";
class ModelMeshController {
    mesh;
    /**
     * Mesh controller that manages a loaded 3D model.
     * @param modelLoader A 3D model loader.
     * @param receiveShadow Whether the mesh should receive shadow.
     * @param castShadow Whether the mesh should cast shadow.
     * @param scale An optional scaling multiplier for the mesh.
     */
    constructor(modelLoader, receiveShadow = true, castShadow = true, scale, rotation) {
        this.mesh = clone(modelLoader.getAsset);
        if (scale) {
            this.mesh.scale.setScalar(scale);
        }
        if (rotation) {
            this.mesh.quaternion.setFromEuler(rotation);
        }
        this.mesh.traverse(object => {
            object.receiveShadow = receiveShadow;
            object.castShadow = castShadow;
        });
    }
    /**
     * Return a vector representing the current dimensions of the mesh.
     * @returns A vector representing the dimensions of the mesh.
     */
    getDimensions() {
        const dimensions = new Vector3();
        new Box3().setFromObject(this.mesh).getSize(dimensions);
        return dimensions;
    }
    get getMesh() {
        return this.mesh;
    }
    /**
     * Get the buffer geometry of the mesh.
     * @throws If no buffer geometry can be found.
     */
    get getGeometry() {
        let geometry = null;
        this.mesh.traverse((object) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (object.isMesh)
                geometry = object.geometry;
        });
        if (!geometry) {
            throw new Error(`Failed to get geometry of ${this.mesh}`);
        }
        return geometry;
    }
}
export { ModelMeshController };
